import {
  START_LOADING, DELETE_USER, GET_USERS_DATA, EDIT_USER, CREATE_USER, USER_ERROR,
  STOP_LOADING,
  GET_ACCESS_RIGHTS,
  GET_CONSULTANT_COST,
  NEW_CONSULTANT_COST,
  ACCESS_RIGHT_ERROR
} from "../usersAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_USERS_DATA:
      return {
        ...state,
        users_list: action.payload,
        success: false,
        loading: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    case CREATE_USER:
      return {
        ...state,
        new_user: action.payload,
        loading: false
      }
    case EDIT_USER:
      return {
        ...state,
        edited_user: action.payload,
        loading: false
      }
    case DELETE_USER:
      return {
        ...state,
        success: true,
        loading: false
      }
    case GET_ACCESS_RIGHTS:
      return {
        ...state,
        user_access_rights: action.payload,
        loading: false
      }
    case GET_CONSULTANT_COST:
      return {
        ...state,
        user_consultant_costs: action.payload,
        loading: false
      }
    case NEW_CONSULTANT_COST:
      return {
        ...state,
        new_consultant_costs: action.payload,
        loading: false
      }
    case USER_ERROR:
      return {
        ...state,
        error_message: action.payload,
        loading: false
      }
    case ACCESS_RIGHT_ERROR:
      return {
        ...state,
        access_error: action.payload,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}